// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderEditScreenComponent_container__3b4w4"};